import { Tab } from "@material-ui/core";
import useStyles from "../../assets/styles/styles";

const ItemTab = (props) => {
  const classes = useStyles();
  return (
    <Tab
      className={classes.itemTab}
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
};

export default ItemTab;
